var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarHomeOff = function SvgNavbarHomeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m20.247 9.75-7.19-7.19-1.06-1.06-1.061 1.06v.001L3.754 9.75H3.75v9.75a3 3 0 0 0 3 3h13.5V9.75zM18.75 21h-12a1.5 1.5 0 0 1-1.5-1.5v-9.126l6.747-6.752 6.753 6.753zM15 18H9v-1.5h6z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarHomeOff;